var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "\\uADF8\\uB8F9 370",
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 75,
    viewBox: "0 0 72 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "zbqrl5jxya"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 717",
    style: {
      fill: "none"
    },
    d: "M0 0h72v75H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 369",
    style: {
      clipPath: "url(#zbqrl5jxya)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 649",
    d: "M49.256 302.569c-.536-.1-1.069-.227-1.609-.285a32.622 32.622 0 0 1-8.057-1.965 36.887 36.887 0 0 1-9.18-5.063 35.411 35.411 0 0 1-9.375-10.582c-.328-.561-.592-1.159-.886-1.74 2.159.145 4.334.177 6.474.462 3.174.423 6.34.946 9.48 1.575a78.5 78.5 0 0 1 11.512 3.529c.07.255.141.51.209.766a10.408 10.408 0 0 0 10.7 7.713c.187-.036.372-.086.56-.107a10.023 10.023 0 0 0 5.592-2.519c.153.1.294.267.461.3 2.52.518 5.045 1.019 7.568 1.523a36.265 36.265 0 0 1-13.661 5.752c-1.183.238-2.4.33-3.593.5a2.866 2.866 0 0 0-.459.143z",
    transform: "translate(-16.192 -227.569)",
    style: {
      fill: "#4fba6f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 650",
    d: "M62.412 210.7c-2.523-.5-5.047-1.006-7.568-1.523-.167-.034-.308-.2-.461-.3l.8-.848a10.176 10.176 0 0 0 1.269-11.887 9.971 9.971 0 0 0-8.361-5.1 9.743 9.743 0 0 0-7.959 3.028 10.487 10.487 0 0 0-2.792 5.3c-.5-.109-1-.221-1.494-.327-6.622-1.4-13.211-3.013-19.993-3.476-2.151-.147-4.315-.112-6.474-.138-.136 0-.274.192-.41.295l-1.622-4.4c.557-.05 1.114-.105 1.672-.148 2.6-.2 5.207-.274 7.783-.614 3.248-.429 6.5-.928 9.693-1.654a102.528 102.528 0 0 0 13.618-4.446c3.714-1.412 7.446-2.786 11.215-4.042a78.472 78.472 0 0 1 18.608-3.434c2.55-.206 5.117-.218 7.676-.319.1 1.689.328 3.38.287 5.065a36.452 36.452 0 0 1-3.312 14.509 37.512 37.512 0 0 1-5.223 8.216 33.083 33.083 0 0 1-6.949 6.248",
    transform: "translate(-5.902 -142.094)",
    style: {
      fill: "#4fba6f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 651",
    d: "M71.708 150.1c-2.559.1-5.125.112-7.676.319a78.473 78.473 0 0 0-18.608 3.434c-3.769 1.256-7.5 2.63-11.215 4.042a102.519 102.519 0 0 1-13.618 4.446c-3.192.726-6.445 1.226-9.693 1.654-2.576.34-5.188.417-7.783.614-.558.042-1.115.1-1.672.148-.387-1.758-.9-3.5-1.126-5.279-.246-1.937-.259-3.907-.31-5.864a30.222 30.222 0 0 1 1.239-8.514c.131-.5.325-.978.49-1.467h8.1c.438.007.877.018 1.315.02q4.934.015 9.868.027l.1.115q0 1.833-.007 3.666a5.748 5.748 0 0 0-3.612 1.369c-1.308 1.122-.705 2.335.213 3a7.1 7.1 0 0 0 3.405 1.2h2.967a6.532 6.532 0 0 0 3.455-1.23c1.052-.812 1.4-1.9.235-2.941a5.653 5.653 0 0 0-3.661-1.4v-3.8h37.1c.318 0 .636-.013.954-.019l8.068.027 1.348 5.961c.036.158.079.315.119.473",
    transform: "translate(0 -115.531)",
    style: {
      fill: "#24ae5f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 652",
    d: "m189.891 41.507-8.068-.027a5.827 5.827 0 0 0-.447-.992c-1.1-1.6-2.164-3.227-3.368-4.745a25.844 25.844 0 0 0-7.859-6.558 28.588 28.588 0 0 0-16.649-3.673c-.119.011-.249-.107-.374-.165l4.053-1.842a1.186 1.186 0 0 0 .848-1.137 1.147 1.147 0 0 0-.788-1.17q-4.174-1.941-8.346-3.887c.775-.141 1.545-.331 2.327-.412a37.289 37.289 0 0 1 3.914-.274c1.4 0 2.805.2 4.21.259a29.462 29.462 0 0 1 6.666 1.278 33.783 33.783 0 0 1 9.552 4.427 35.949 35.949 0 0 1 11.135 11.7 32.072 32.072 0 0 1 3.195 7.22",
    transform: "translate(-119.65 -13.371)",
    style: {
      fill: "#b0d3f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 653",
    d: "M16.938 58.643h-8.1a34.4 34.4 0 0 1 6.226-11.5 36.045 36.045 0 0 1 10.81-9.013 2.56 2.56 0 0 1 .542-.161c.011.486.028.971.032 1.457q.032 4.044.06 8.089a1.6 1.6 0 0 1-.272.336 27.185 27.185 0 0 0-6.336 6.067c-1.093 1.5-1.981 3.146-2.961 4.726",
    transform: "translate(-7.102 -30.535)",
    style: {
      fill: "#b0d3f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 654",
    d: "m123.614 10.532 8.346 3.887a1.147 1.147 0 0 1 .788 1.17 1.187 1.187 0 0 1-.848 1.137l-4.053 1.842c-.805.347-1.612.69-2.416 1.042q-3.553 1.552-7.1 3.11c-.3-.446-.839-.887-.846-1.337-.067-4-.046-8-.032-12a1.08 1.08 0 0 1 .957-1.183c.774.33 1.554.648 2.321.993.967.436 1.923.894 2.884 1.343",
    transform: "translate(-94.371 -6.592)",
    style: {
      fill: "#e64d3d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 655",
    d: "M15.6 272.864c.137-.1.275-.3.41-.295 2.158.026 4.323-.009 6.474.138 6.783.464 13.371 2.073 19.993 3.476.5.106 1 .218 1.494.327l-.013 3.652a78.5 78.5 0 0 0-11.511-3.528 148.18 148.18 0 0 0-9.48-1.575c-2.14-.285-4.315-.317-6.474-.462l-.892-1.733",
    transform: "translate(-12.539 -219.232)",
    style: {
      fill: "#24ae5f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 656",
    d: "M103.05 1.6a1.08 1.08 0 0 0-.959 1.184c-.014 4-.035 8 .032 12 .007.45.551.892.846 1.338a.305.305 0 0 0-.016.106l-2.812 1.272a.165.165 0 0 0-.125.065 1.631 1.631 0 0 1-1.6-.586q-.029-4.045-.06-8.089c0-.485-.021-.971-.032-1.457.006-1.919.066-3.839 0-5.755-.052-1.5.928-2.088 2.184-1.371.826.471 1.693.87 2.542 1.3",
    transform: "translate(-79.011)",
    style: {
      fill: "#e64d3d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 657",
    d: "M200.894 250.159a9.972 9.972 0 0 1 8.361 5.1 10.176 10.176 0 0 1-1.268 11.887l-.8.848a10.024 10.024 0 0 1-5.592 2.519c-.188.022-.374.071-.56.107a2.558 2.558 0 0 1 .238-.427 1.3 1.3 0 0 0-.251-2.037c.028-1.108-.053-1.188-1.165-1.163a11.217 11.217 0 0 1-2.205-4.257c.494-.5.168-.906-.157-1.311q0-1.1.007-2.207c.3-.339.583-.681.29-1.166a3.352 3.352 0 0 1 .177-.987c.6-1.152 1.254-2.276 1.888-3.41 1.008.251 1.195.063 1.168-1.172.9-.739.849-1.573-.131-2.32m.262 6.676c-.142-.627-.414-.93-.86-.814-.275.071-.477.418-.712.642.277.257.518.619.845.728.162.054.48-.355.728-.555m0 7.337c-.141-.618-.389-.941-.845-.828-.277.069-.486.411-.726.63.273.262.509.627.835.742.161.057.486-.348.737-.544m-1.044-4.622c-.174.265-.539.587-.48.781a1.19 1.19 0 0 0 .738.73c.4.076.706-.24.669-.737s-.308-.68-.928-.775m8.383 1.012c-.1-.62-.306-.881-.792-.911s-.81.277-.726.678a1.191 1.191 0 0 0 .743.726c.194.056.513-.314.776-.493m-4.975 2.317c.542.013.784-.348.707-.734-.055-.275-.438-.484-.674-.722-.249.25-.651.47-.708.757a.585.585 0 0 0 .676.7m1.2 3.825c-.008-.471-.238-.833-.69-.714a1.121 1.121 0 0 0-.692.736c-.032.186.4.591.679.659.455.111.689-.233.7-.681m-1.2-7.487c.542.012.785-.349.707-.735-.055-.275-.438-.484-.674-.722-.249.25-.651.47-.708.758a.585.585 0 0 0 .675.7m3.147-3.518a4.536 4.536 0 0 0-.618.979.54.54 0 0 0 .592.714 1.328 1.328 0 0 0 .8-.753c.058-.147-.388-.492-.77-.941m.149 7.5-.317.018a3.338 3.338 0 0 0-.451.831.542.542 0 0 0 .637.677 1.122 1.122 0 0 0 .742-.721c.034-.233-.39-.534-.612-.805M204 255.012c.34-.47.711-.765.666-.972-.064-.3-.427-.539-.663-.8-.248.264-.62.5-.7.8-.05.193.339.5.7.972",
    transform: "translate(-158.706 -201.207)",
    style: {
      fill: "#e9efff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 658",
    d: "M169.719 253.485c-.634 1.134-1.288 2.259-1.888 3.41a3.349 3.349 0 0 0-.177.987c-.26-.087-.608-.319-.761-.228a1.13 1.13 0 0 0-.524.78c-.016.647.52.63 1 .614q0 1.1-.007 2.207a3.2 3.2 0 0 0-.967.462.8.8 0 0 0 .141.758 2.515 2.515 0 0 0 .983.091 11.213 11.213 0 0 0 2.205 4.257c-.153.4-.475.8-.005 1.21.414.364.789.181 1.171-.047a1.3 1.3 0 0 1 .251 2.037 2.559 2.559 0 0 0-.238.427 10.408 10.408 0 0 1-10.7-7.713c-.069-.256-.14-.511-.21-.766l.013-3.652a10.487 10.487 0 0 1 2.792-5.3 9.742 9.742 0 0 1 7.959-3.028c.981.747 1.028 1.581.131 2.32-.462-.13-.993-.348-1.267.215-.119.245.057.633.1.957m-5.895 2.341a.609.609 0 0 0-.678.754c.061.273.455.472.7.7.242-.262.623-.491.693-.792.107-.465-.271-.672-.715-.666m.778 8.164c-.083-.694-.407-.946-.827-.807-.269.088-.667.524-.617.683.093.295.464.683.731.691s.533-.41.713-.566m2.621 2.429c-.014-.359-.234-.713-.7-.6-.283.071-.714.474-.682.659a1.124 1.124 0 0 0 .693.737c.453.12.683-.24.687-.8m-.958-11.81c.617-.086 1.005-.261.923-.743-.05-.292-.394-.534-.606-.8-.269.242-.658.442-.765.741-.068.191.284.529.448.8m-3.258 4.77-.313.006c-.2.282-.592.605-.543.836.058.278.492.478.763.712.209-.263.551-.51.585-.794.027-.231-.315-.506-.493-.761",
    transform: "translate(-128.569 -201.042)",
    style: {
      fill: "#d3dcfb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 659",
    d: "M121.9 65.463a.31.31 0 0 1 .016-.106l7.1-3.11c.8-.351 1.611-.694 2.416-1.041.125.058.255.175.374.165a28.587 28.587 0 0 1 16.648 3.672 25.844 25.844 0 0 1 7.859 6.558c1.2 1.518 2.265 3.149 3.368 4.744a5.843 5.843 0 0 1 .447.993c-.318.007-.636.019-.954.019h-37.1c-.009-.315-.024-.63-.025-.945q-.014-5.388-.023-10.777l-.11-.122z",
    transform: "translate(-97.956 -49.228)",
    style: {
      fill: "#b0d3f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 660",
    d: "M59.651 86.747a1.631 1.631 0 0 0 1.6.586l.122.165v10.257l-.117.125.01.047-9.868-.027c-.438 0-.877-.013-1.315-.02.98-1.581 1.868-3.227 2.962-4.726a27.185 27.185 0 0 1 6.335-6.072 1.6 1.6 0 0 0 .272-.336",
    transform: "translate(-40.246 -69.772)",
    style: {
      fill: "#b0d3f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 661",
    d: "M107.531 94.713V84.226l2.811-1.262.016.052.11.122.023 10.777c0 .315.016.63.025.945v3.8l-.048.3c-.861 1.4-1.886 1.454-2.9.143l-.052-.44q0-1.833.007-3.666a.145.145 0 0 0 .008-.134c0-.051 0-.1-.006-.153",
    transform: "translate(-86.405 -66.729)",
    style: {
      fill: "#cb8252"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 662",
    d: "m89.63 163.206.052.44-.051 5.121a7.1 7.1 0 0 1-3.405-1.2c-.919-.661-1.521-1.874-.213-3a5.748 5.748 0 0 1 3.618-1.363",
    transform: "translate(-68.513 -131.27)",
    style: {
      fill: "#148230"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 663",
    d: "m122.535 163.5.048-.3a5.653 5.653 0 0 1 3.661 1.4c1.161 1.045.818 2.129-.235 2.941a6.53 6.53 0 0 1-3.454 1.221l-.02-5.262",
    transform: "translate(-98.469 -131.265)",
    style: {
      fill: "#148230"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 664",
    d: "m110.475 164.723.02 5.262h-2.967l.051-5.121c1.011 1.311 2.036 1.261 2.9-.143",
    transform: "translate(-86.409 -132.49)",
    style: {
      fill: "#845b44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 665",
    d: "M107.094 143.672a.145.145 0 0 1-.008.134l-.1-.115-.01-.046a.443.443 0 0 0 .123.027",
    transform: "translate(-85.962 -115.536)",
    style: {
      fill: "#91b02f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 666",
    d: "M107.073 89.414v.23l-.122-.165a.165.165 0 0 1 .125-.065",
    transform: "translate(-85.943 -71.917)",
    style: {
      fill: "#fdcb4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 667",
    d: "M209.7 280.828c-.248.2-.566.609-.728.555-.327-.109-.568-.47-.845-.728.235-.223.438-.571.713-.642.446-.115.718.187.86.814",
    transform: "translate(-167.254 -225.201)",
    style: {
      fill: "#c0caf7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 668",
    d: "M209.7 318.275c-.251.2-.576.6-.737.544-.325-.115-.562-.48-.835-.742.24-.219.449-.561.726-.63.456-.113.7.21.845.828",
    transform: "translate(-167.248 -255.31)",
    style: {
      fill: "#c0caf7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 669",
    d: "M208.822 298.15c.62.095.892.287.928.775s-.264.813-.669.736a1.189 1.189 0 0 1-.738-.73c-.059-.194.305-.516.48-.781",
    transform: "translate(-167.419 -239.807)",
    style: {
      fill: "#c0caf7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 670",
    d: "M247.225 299.569c-.263.179-.581.549-.776.492a1.191 1.191 0 0 1-.743-.726c-.083-.4.225-.709.726-.678s.692.291.793.911",
    transform: "translate(-197.438 -240.214)",
    style: {
      fill: "#c0caf7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 671",
    d: "M225.346 309.18a.585.585 0 0 1-.676-.7c.057-.288.46-.507.708-.758.236.238.619.448.674.722.078.386-.165.747-.707.734",
    transform: "translate(-180.535 -247.508)",
    style: {
      fill: "#c0caf7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 672",
    d: "M209.663 337.315c-.381.228-.757.411-1.171.047-.47-.414-.147-.808.005-1.21 1.112-.025 1.193.056 1.165 1.163",
    transform: "translate(-167.347 -270.37)",
    style: {
      fill: "#bfc9f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 673",
    d: "M228.6 331.682c-.013.448-.247.792-.7.681-.282-.069-.711-.473-.679-.66a1.121 1.121 0 0 1 .692-.736c.452-.118.682.243.69.714",
    transform: "translate(-182.589 -266.185)",
    style: {
      fill: "#c0caf7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 674",
    d: "M208.949 262.559c-.042-.323-.218-.711-.1-.956.274-.563.8-.345 1.267-.215.027 1.235-.161 1.423-1.168 1.172",
    transform: "translate(-167.799 -210.116)",
    style: {
      fill: "#c0caf7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 675",
    d: "M193.458 290.618c-.475.017-1.011.033-1-.613a1.129 1.129 0 0 1 .524-.78c.154-.091.5.141.761.228.293.485.007.827-.29 1.166",
    transform: "translate(-154.662 -232.611)",
    style: {
      fill: "#bfc9f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 676",
    d: "M225.346 290.467a.584.584 0 0 1-.675-.7c.057-.288.459-.508.708-.758.236.238.619.447.674.722.078.386-.165.747-.707.735",
    transform: "translate(-180.535 -232.457)",
    style: {
      fill: "#c0caf7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 677",
    d: "M193.5 309.021a2.515 2.515 0 0 1-.983-.091.8.8 0 0 1-.141-.758 3.2 3.2 0 0 1 .968-.462c.325.4.651.809.157 1.311",
    transform: "translate(-154.551 -247.497)",
    style: {
      fill: "#bfc9f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 678",
    d: "M241.558 278.478c.382.449.828.793.77.94a1.328 1.328 0 0 1-.8.753.54.54 0 0 1-.592-.715 4.54 4.54 0 0 1 .618-.979",
    transform: "translate(-193.6 -223.985)",
    style: {
      fill: "#c0caf7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 679",
    d: "M241.736 316.791c.221.271.646.572.612.805a1.122 1.122 0 0 1-.742.721.542.542 0 0 1-.637-.677 3.334 3.334 0 0 1 .451-.831l.317-.018",
    transform: "translate(-193.629 -254.801)",
    style: {
      fill: "#c0caf7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 680",
    d: "M227.749 267.66c-.356-.473-.745-.779-.7-.972.079-.307.451-.54.7-.8.236.265.6.5.663.8.044.207-.326.5-.666.972",
    transform: "translate(-182.456 -213.855)",
    style: {
      fill: "#c0caf7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 681",
    d: "M176.662 279.964c.444-.006.822.2.714.666-.069.3-.451.531-.692.792-.245-.232-.639-.431-.7-.7a.609.609 0 0 1 .678-.754",
    transform: "translate(-141.407 -225.18)",
    style: {
      fill: "#bfc9f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 682",
    d: "M177.545 318.216c-.18.156-.453.574-.713.566s-.638-.4-.731-.691c-.05-.158.348-.594.617-.683.42-.138.744.114.827.807",
    transform: "translate(-141.511 -255.268)",
    style: {
      fill: "#bfc9f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 683",
    d: "M191.166 331.551c0 .558-.234.919-.687.8a1.124 1.124 0 0 1-.692-.737c-.032-.185.4-.588.682-.659.463-.116.683.238.7.6",
    transform: "translate(-152.511 -266.174)",
    style: {
      fill: "#bfc9f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 684",
    d: "M190.068 267.406c-.164-.272-.516-.61-.448-.8.106-.3.5-.5.764-.741.212.265.557.507.606.8.082.482-.306.657-.923.743",
    transform: "translate(-152.372 -213.839)",
    style: {
      fill: "#bfc9f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 685",
    d: "M171.832 298.117c.178.255.52.53.493.761-.034.284-.376.531-.585.794-.271-.234-.705-.434-.763-.712-.049-.231.345-.554.543-.836l.313-.006",
    transform: "translate(-137.393 -239.781)",
    style: {
      fill: "#bfc9f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 686",
    d: "m122.088 83.35-.11-.122.11.122",
    transform: "translate(-98.021 -66.942)",
    style: {
      fill: "#e8ebea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 687",
    d: "M107.094 143.156a.442.442 0 0 1-.123-.027l.117-.126c0 .051 0 .1.006.153",
    transform: "translate(-85.962 -115.02)",
    style: {
      fill: "#fdcb4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 688",
    d: "M177.085 254a11.126 11.126 0 1 1-11.126-11.085A11.105 11.105 0 0 1 177.085 254",
    transform: "translate(-124.424 -195.378)",
    style: {
      fill: "#fff"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 689",
    d: "M43.92 60.993a.793.793 0 0 1-.795-.792v-1.979a.795.795 0 0 1 1.589 0v1.979a.793.793 0 0 1-.795.792"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 690",
    d: "M46.701 59.806a.793.793 0 0 1-.795-.792v-1.98a.795.795 0 0 1 1.589 0v1.98a.793.793 0 0 1-.795.792"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 691",
    d: "M175.082 310.16c.777.706 1.115 1.6.756 1.99s-1.281.138-2.057-.568-1.115-1.6-.756-1.99 1.281-.138 2.058.568",
    transform: "translate(-138.927 -248.862)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 692",
    d: "M177.105 326.345c.777.706 1.115 1.6.756 1.99s-1.281.138-2.057-.568-1.115-1.6-.756-1.99 1.281-.138 2.058.568",
    transform: "translate(-140.553 -261.879)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 693",
    d: "M195.313 326.345c.777.706 1.115 1.6.756 1.99s-1.281.138-2.057-.568-1.115-1.6-.756-1.99 1.281-.138 2.058.568",
    transform: "translate(-155.185 -261.879)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 694",
    d: "m183.158 193.655 3.973 6.73 4.371-7.126a6.135 6.135 0 0 0-4.371-1.188c-2.384.4-3.973.792-3.973 1.583",
    transform: "translate(-147.186 -154.436)",
    style: {
      fill: "#00dd4d"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 695",
    d: "M41.634 46.543c-.168 0-.331.018-.5.025v-.421c.016-.025.038-.044.053-.07l3.681-6.532a.784.784 0 0 0 .072-.174 1.229 1.229 0 0 0 .164-.608c0-1.561-2.716-2.114-5.043-2.114s-5.043.554-5.043 2.114a1.231 1.231 0 0 0 .164.608.786.786 0 0 0 .071.176l3.682 6.551a1.335 1.335 0 0 0 .215.275v.427a12.224 12.224 0 1 0 2.483-.254m-1.572-8.314a8.194 8.194 0 0 1 3.243.531 10.163 10.163 0 0 1-6.486 0 8.2 8.2 0 0 1 3.243-.531m-2.355 2.439a13.541 13.541 0 0 0 4.708 0l-2.01 3.567a.4.4 0 0 1-.693 0zm3.927 28.242a10.184 10.184 0 0 1-2.483-20.072v.673a.994.994 0 0 0 1.987 0v-.965c.166-.008.329-.025.5-.025a10.194 10.194 0 1 1 0 20.388"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 696",
    d: "M45.435 64.754a2.3 2.3 0 0 1-.821-.152 2.55 2.55 0 0 1-1.53-1.72.794.794 0 0 1 1.529-.432.983.983 0 0 0 .569.674.7.7 0 0 0 .645-.07c.245-.155.477-.3.477-1.268a.795.795 0 0 1 1.589 0 2.686 2.686 0 0 1-1.218 2.607 2.324 2.324 0 0 1-1.24.363"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 697",
    d: "M198.553 57.587a4.49 4.49 0 0 1 2.024-3.243 4.573 4.573 0 0 1 6.961 2.528c.175.615.444.785 1.013.726a3.819 3.819 0 0 1 3.979 1.917 3.928 3.928 0 0 1-2.663 5.791 10.453 10.453 0 0 1-1.683.146c-3.559.013-7.119.024-10.677 0a4.027 4.027 0 0 1-3.925-2.357 3.87 3.87 0 0 1 3.471-5.518c.479.044.965.006 1.5.006",
    transform: "translate(-155.262 -43.08)",
    style: {
      fill: "#ecf0f1"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreate);
export default __webpack_public_path__ + "static/media/create.a749a38342c543582bd889f548bfd400.svg";
export { ForwardRef as ReactComponent };